import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./QuickActions.module.scss";
import basket from "../../assets/images/icons/basket.svg";
import message from "../../assets/images/icons/message.svg";
import orders from "../../assets/images/icons/orders.svg";
import info from "../../assets/images/icons/info.svg";

const QuickActions = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("translation");
  return (
    <section className={styles.quick_actions_section}>
      <h2 className={styles.section_title}>{t("quick_actions")}</h2>
      <div className={styles.actions_container}>
        <div
          className={styles.action_card}
          onClick={() => navigate("/dashboard/products/create")}
        >
          <div className={styles.action_icon}>
            <img src={basket} alt="Create Product" />
          </div>
          <div className={styles.action_details}>
            <p className={styles.action_title}>{t("create_product")}</p>
            <span className={styles.action_subtitle}>
              {t("quick_actions_add_product_sub")}
            </span>
          </div>
        </div>
        <div
          className={styles.action_card}
          onClick={() => navigate("/dashboard/messages")}
        >
          <div className={styles.action_icon}>
            <img src={message} alt="Messages" />
          </div>
          <div className={styles.action_details}>
            <p className={styles.action_title}>{t("messages")}</p>
            <span className={styles.action_subtitle}>
              {t("quick_actions_admin_message_sub")}
            </span>
          </div>
        </div>
        <div
          className={styles.action_card}
          onClick={() => navigate("/dashboard/delivery")}
        >
          <div className={styles.action_icon}>
            <img src={orders} alt="Orders" />
          </div>
          <div className={styles.action_details}>
            <p className={styles.action_title}>{t("orders")}</p>
            <span className={styles.action_subtitle}>
              {t("quick_actions_orders_sub")}
            </span>
          </div>
        </div>
        <div
          className={styles.action_card}
          onClick={() => navigate("/dashboard/products/low-stock")}
        >
          <div className={styles.action_icon}>
            <img src={info} alt="Low Stock" />
          </div>
          <div className={styles.action_details}>
            <p className={styles.action_title}>
              {t("quick_actions_low_stock")}
            </p>
            <span className={styles.action_subtitle}>
              {t("quick_actions_low_stock_sub")}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuickActions;
